import { render } from "./Trees.vue?vue&type=template&id=8fa3f7b4"
import script from "./Trees.vue?vue&type=script&lang=js"
export * from "./Trees.vue?vue&type=script&lang=js"

import "./Trees.vue?vue&type=style&index=0&id=8fa3f7b4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__